// extracted by mini-css-extract-plugin
export var fileUpload = "_e1-1";
export var modalButton = "_e1-0";